import { createSelector } from 'reselect';
import { branchSelector } from '../../../Organisation/scenes/Branch/BranchSelectors';

export const departmentListSelector = createSelector(branchSelector, branch =>
  branch ? branch.departments : []
);

export const loadingDepartmentsSelector = state => state.departmentReducer.loadingDepartments;
